import { combineReducers } from "redux";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { unAuthorized } from "../../../auth/Auth.ducks";

export const GET_ARCHIVE_ENFANT_PENDING = "GET_ARCHIVE_ENFANT_PENDING";
export const GET_ARCHIVE_ENFANT_REJECTED = "GET_ARCHIVE_ENFANT_REJECTED";
export const GET_ARCHIVE_ENFANT_FULFILLED = "GET_ARCHIVE_ENFANT_FULFILLED";

export const GET_ARCHIVE_ONE_KID_PENDING = "GET_ARCHIVE_ONE_KID_PENDING";
export const GET_ARCHIVE_ONE_KID_REJECTED = "GET_ARCHIVE_ONE_KID_REJECTED";
export const GET_ARCHIVE_ONE_KID_FULFILLED = "GET_ARCHIVE_ONE_KID_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case GET_ARCHIVE_ENFANT_PENDING:
      return true;
    case GET_ARCHIVE_ENFANT_REJECTED:
    case GET_ARCHIVE_ENFANT_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ARCHIVE_ENFANT_PENDING:
    case GET_ARCHIVE_ENFANT_FULFILLED:
      return null;
    case GET_ARCHIVE_ENFANT_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ARCHIVE_ENFANT_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    default:
      return state;
  }
};

const archivedKid = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ARCHIVE_ONE_KID_FULFILLED: {
      return _.isEmpty(payload)
        ? null
        : Object.assign({}, state, { [payload.id]: payload });
    }

    default:
      return state;
  }
};

export default combineReducers({ loading, error, data, archivedKid });

export const getArchivesEnfants = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_ARCHIVE_ENFANT_PENDING });
    const response = Service.get(
      `${API}api/enfant/creche/enfants/archives?offset=1&path-size=20`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: GET_ARCHIVE_ENFANT_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_ARCHIVE_ENFANT_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const getArchiveOneKid = (data) => {
  return (dispatch) => {
    if (!_.isEmpty(data)) {
      dispatch({ type: GET_ARCHIVE_ONE_KID_FULFILLED, payload: data });
    }
  };
};
